import { RootState } from '@/plugins/store';
import { ActionTree, Commit } from 'vuex';
import { EmailSuivi, OptionsSuiviInterventionState, SuiviDI } from './state';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ErrorManager from '@/common/utils/ErrorManager';
import {
    OptionsSuiviDIModuleAction,
    SuiviDIModuleActionTypes
} from '@/modules/OptionsSuiviInterventions/store/actions-types';
import OptionsSuiviInterventionService
    from '@/modules/OptionsSuiviInterventions/services/OptionsSuiviInterventionService';
import { AxiosResponse } from 'axios';
import { OPTIONS_SUIVI } from '@/modules/OptionsSuiviInterventions/store/mutation-types';

export const actions: ActionTree<OptionsSuiviInterventionState, RootState> = {

    async [OptionsSuiviDIModuleAction.GET_SUIVI_DI](actionTypes: SuiviDIModuleActionTypes) {
        await traitementSuiviDI(actionTypes, OptionsSuiviInterventionService.getSuiviDI);
    },

    [OptionsSuiviDIModuleAction.ACTIVER_SUIVI_DI](actionTypes: SuiviDIModuleActionTypes) {
        traitementSuiviDI(actionTypes, OptionsSuiviInterventionService.activerSuiviDI);
    },

    [OptionsSuiviDIModuleAction.DESACTIVER_SUIVI_DI](actionTypes: SuiviDIModuleActionTypes) {
        traitementSuiviDI(actionTypes, OptionsSuiviInterventionService.desactiverSuiviDI);
    },

    [OptionsSuiviDIModuleAction.ACTIVER_EMAIL_SUIVI](actionTypes: SuiviDIModuleActionTypes, email: EmailSuivi) {
        traitementEmailSuivi(actionTypes, email.id, OptionsSuiviInterventionService.activerEmailSuivi);
    },

    [OptionsSuiviDIModuleAction.DESACTIVER_EMAIL_SUIVI](actionTypes: SuiviDIModuleActionTypes, email: EmailSuivi) {
        traitementEmailSuivi(actionTypes, email.id, OptionsSuiviInterventionService.desactiverEmailSuivi);
    },

    [OptionsSuiviDIModuleAction.SUPPRIMER_EMAIL_SUIVI](actionTypes: SuiviDIModuleActionTypes, email: EmailSuivi) {
        traitementEmailSuivi(actionTypes, email.id, OptionsSuiviInterventionService.supprimerEmailSuivi);
    },

    [OptionsSuiviDIModuleAction.AJOUTER_EMAIL_SUIVI](actionTypes: SuiviDIModuleActionTypes) {
        if (actionTypes.state.suiviDI.actif && /\S+@\S+\.\S+/.test(actionTypes.state.newEmail)) {
            actionTypes.state.isLoading = true;
            return OptionsSuiviInterventionService.ajouterEmailSuivi(actionTypes.state.newEmail)
                .then(() => {
                    return actionTypes.dispatch(OptionsSuiviDIModuleAction.GET_SUIVI_DI)
                        .then(() => actionTypes.commit(OPTIONS_SUIVI.SET_EMAIL, ''));
                })
                .catch(e => onError(e, actionTypes.commit))
                .finally( () => actionTypes.state.isLoading = false);
        }
    }

};

function traitementSuiviDI({ state, commit }: SuiviDIModuleActionTypes, service: () => Promise<AxiosResponse<SuiviDI>>){
    state.isLoading = true;
    return service()
        .then(r => state.suiviDI = r.data)
        .catch(e => onError(e, commit))
        .finally( () => state.isLoading = false);
}

function traitementEmailSuivi({ state, commit, dispatch }: SuiviDIModuleActionTypes, param: number | string, service: (param: any) => Promise<AxiosResponse<EmailSuivi>>){
    if (state.suiviDI.actif) {
        state.isLoading = true;
        service(param)
            .then(() => dispatch(OptionsSuiviDIModuleAction.GET_SUIVI_DI))
            .catch(e => onError(e, commit))
            .finally( () => state.isLoading = false);
    }
}

async function onError(error: any, commit: Commit) {
    commit(
        `errorToaster/${ERROR.SET_MESSAGE}`,
        await ErrorManager.processError(error),
        {root: true}
    );
}
